// extracted by mini-css-extract-plugin
export default {"Session_container":"Footer_Session_container__0qxPs","Footer_container":"Footer_Footer_container__CpMPm"};